import { t } from 'i18next';
import { observer } from 'mobx-react';

import { useMeasurement } from '@/hooks/useMeasurement';
import {
  getDeviceSliderPointsArray,
  useMinSetpointValue,
  useSetpointValue,
} from '@/comp/MapBuilder/nodes/compressor/CompressorNodeWidget.utils';
import { CompressorActivityStateEnum } from '@/constants/enums';
import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';

import Slider from '../Slider/Slider';
import { DeviceType } from '@/constants/deviceTypeEnum';
import { MetricType } from '@/constants/metric-type.enum';
import { aerationBasinOnDevicesTypes, getOnDeviceSensorsToDisplay, Sensor } from '@/comp/MapBuilder/utils/utils';
import { useStores } from '@/hooks/use-stores';

const AerationBasinSliders = observer(({ entity }: { entity: Entity }) => {
  const { tvalue, tunit } = useMeasurement();
  const { stationStore } = useStores();
  const {
    connectivity,
    activity,
    dissolvedOxygenPPM,
    targetDissolvedOxygenPPM,
    minimumDissolvedOxygenPPM,
    maximumDissolvedOxygenPPM,
  } = entity;

  const onDevices = stationStore.currentStation?.devices?.filter(device => entity.onDevices.includes(device.deviceId));
  const aerationBasinOnDevices = getOnDeviceSensorsToDisplay(onDevices, [
    ...aerationBasinOnDevicesTypes,
    DeviceType.DissolvedOxygenSensor,
  ]);
  const firstDissolvedOxygenSensor = aerationBasinOnDevices[aerationBasinOnDevices?.length - 1]?.[0] as Sensor;

  return (
    <div className="main-slider">
      <Slider
        showTierLock
        title={t('dissolvedOxygen')}
        value={tvalue(Number(dissolvedOxygenPPM?.toFixed(2) ?? firstDissolvedOxygenSensor?.dissolvedOxygenPPM), 'ppm')}
        unit={t(tunit('ppm'))}
        min={useMinSetpointValue(entity, MetricType.MinimumDissolvedOxygenPPM)}
        max={useSetpointValue(entity, MetricType.MaximumDissolvedOxygenPPM)}
        points={getDeviceSliderPointsArray(
          targetDissolvedOxygenPPM,
          minimumDissolvedOxygenPPM,
          maximumDissolvedOxygenPPM,
          t,
          tvalue,
          DeviceType.AerationBasin,
          'ppm',
        )}
        connectivity={connectivity}
        highlightSlider={activity?.toLowerCase() === CompressorActivityStateEnum.Load}
        addSideGaps
        hasTarget
      />
    </div>
  );
});

export default AerationBasinSliders;
